module.exports = __webpack_public_path__ + "img/circle-xmark-regular-full.ebf7dca0.svg";